import { useEffect, useState, useCallback } from "react";
import styles from "./VisitorJugador.module.css";
import { getVisitorPublicaciones, getVisitorUser } from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import StadisticsVisitor from "./componentes/Stadistics/StadisticsVisitor.jsx";
import { useParams } from "react-router";
import UserVisitor from "../User/UserVisitor.jsx";
import FeedVisitor from "../Feed/FeedVisitor.jsx";
import axios from "axios";
import { URL } from "../../link";
import NavSecond from "../../sharedComponents/NavSecond/NavSecond.jsx";

const VisitorJugador = ({
  inVisitor,
  noticias,
  publicacionView,
  seguir,
  isMobile
}) => {
  const params = useParams();
  const id = params.id;
  const dispatch = useDispatch();
  const detailUser = useSelector((state) => state.dataVisitorUser);
  const publicaciones = useSelector((state) => state.visitorPublicaciones);
  const [entrenamientos, setEntrenamientos] = useState([]);
  const userPubliaciones = [];
  const [metricaBool, setMetricaBool] = useState(false);
  const [scores, setScores] = useState([]);
  const [metricas, setMetricas] = useState([]);

  const [displayShow, setDisplayShow] = useState("MÉTRICAS");
  const [showNavSecond, setShowNavSecond] = useState(true);

  const handleDisplayShow = (display) => {
    setDisplayShow(display);
  };

  const getScores = async () => {
    try {
      if (detailUser.rol === "Jugador") {
        const response = await axios.get(`${URL}/score/${detailUser.id}`);
        setScores(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getMetricas = async () => {
    try {
      const response = await axios.get(`${URL}/metrica/user/${detailUser.id}`);
      setMetricas(response.data.Metricas);
    } catch (error) {
      console.log(error);
    }
  };

  const getEntrenamientos = async () => {
    try {
      const response = await axios.get(`${URL}/entrenamiento/user/${id}`);
      setEntrenamientos(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(getVisitorUser(id));
    dispatch(getVisitorPublicaciones(id));
    getEntrenamientos();
    getScores();
    getMetricas();
  }, [dispatch, id]);


  return (
    <>
      {isMobile ? (
        <div className={styles.container}>
          <div
            className={styles.leftContainer}
            style={{ display: displayShow === "MÉTRICAS" ? "flex" : "none" }}
          >
            <StadisticsVisitor
              detailUser={detailUser}
              entrenamientos={entrenamientos}
              isMobile={isMobile}
              setMetricaBool={setMetricaBool}
              metricaBool={metricaBool}
              setShowNavSecond={setShowNavSecond}
            />
          </div>

          <div
            className={styles.subContainer}
            style={{ display: displayShow === "MÉTRICAS" ? "flex" : "none" }}
          >
            <UserVisitor
              user={detailUser}
              scores={scores}
              entrenamientos={entrenamientos}
              metricas={metricas}
              isMobile={isMobile}
              setShowNavSecond={setShowNavSecond}
            />
          </div>

          <div
            className={styles.subContainer}
            style={{ display: displayShow === "SOCIAL" ? "flex" : "none" }}
          >
            <FeedVisitor
              user={detailUser}
              publicaciones={publicaciones}
              userPubliaciones={userPubliaciones}
              inVisitor={inVisitor}
              noticias={noticias}
              publicacionView={publicacionView}
              seguir={seguir}
            />
          </div>

          {showNavSecond && (
            <div className={styles.navSecond}>
              <NavSecond
                handleDisplayShow={handleDisplayShow}
                displayShow={displayShow}
                user={detailUser}
                isVisitor={false}
              />
            </div>
          )}
        </div>
      ) : (
        <div className={styles.container}>
         <div className={styles.leftContainer}>
            <StadisticsVisitor
              detailUser={detailUser}
              entrenamientos={entrenamientos}
              isMobile={isMobile}
              setMetricaBool={setMetricaBool}
              metricaBool={metricaBool}
              setShowNavSecond={setShowNavSecond}
            />
          </div>

          <div className={styles.subContainer}>
            <UserVisitor
              user={detailUser}
              scores={scores}
              entrenamientos={entrenamientos}
              metricas={metricas}
              isMobile={isMobile}
              setShowNavSecond={setShowNavSecond}
            />
          </div>

          <div className={styles.subContainer}>
            <FeedVisitor
              user={detailUser}
              publicaciones={publicaciones}
              userPubliaciones={userPubliaciones}
              inVisitor={inVisitor}
              noticias={noticias}
              publicacionView={publicacionView}
              seguir={seguir}
              isMobile={isMobile}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default VisitorJugador;
